'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _web3_tools = require('../utils/web3_tools');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MultisigWalletJson = require('../contracts/MultiSigWallet.json'); /*
                                                                      Copyright: Ambrosus Inc.
                                                                      Email: tech@ambrosus.io
                                                                      
                                                                      This Source Code Form is subject to the terms of the Mozilla Public License, v. 2.0. If a copy of the MPL was not distributed with this file, You can obtain one at https://mozilla.org/MPL/2.0/.
                                                                      
                                                                      This Source Code Form is “Incompatible With Secondary Licenses”, as defined by the Mozilla Public License, v. 2.0.
                                                                      */

var MultiplexerJson = require('../contracts/Multiplexer.json');

var AdministrativeActions = function () {
  function AdministrativeActions(headWrapper, kycWhitelistWrapper, feesWrapper, validatorProxyWrapper, blockchainStateWrapper, poolsNodesManagerWrapper, rolesWrapper) {
    (0, _classCallCheck3.default)(this, AdministrativeActions);

    this.headWrapper = headWrapper;
    this.kycWhitelistWrapper = kycWhitelistWrapper;
    this.feesWrapper = feesWrapper;
    this.validatorProxyWrapper = validatorProxyWrapper;
    this.blockchainStateWrapper = blockchainStateWrapper;
    this.poolsNodesManagerWrapper = poolsNodesManagerWrapper;
    this.rolesWrapper = rolesWrapper;
  }

  (0, _createClass3.default)(AdministrativeActions, [{
    key: 'moveOwnershipsToMultiplexer',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(multiplexerAddress) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.headWrapper.transferOwnership(multiplexerAddress);

              case 2:
                _context.next = 4;
                return this.kycWhitelistWrapper.transferOwnership(multiplexerAddress);

              case 4:
                _context.next = 6;
                return this.feesWrapper.transferOwnership(multiplexerAddress);

              case 6:
                _context.next = 8;
                return this.validatorProxyWrapper.transferOwnership(multiplexerAddress);

              case 8:
                _context.next = 10;
                return this.poolsNodesManagerWrapper.transferOwnership(multiplexerAddress);

              case 10:
                _context.next = 12;
                return this.rolesWrapper.transferOwnership(multiplexerAddress);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function moveOwnershipsToMultiplexer(_x) {
        return _ref.apply(this, arguments);
      }

      return moveOwnershipsToMultiplexer;
    }()
  }, {
    key: 'switchContext',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(newContextAddress) {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.headWrapper.getOwner();

              case 2:
                _context2.t0 = _context2.sent;
                _context2.t1 = this.headWrapper.defaultAddress;

                if (!(_context2.t0 !== _context2.t1)) {
                  _context2.next = 6;
                  break;
                }

                throw new Error('You need to be the owner of the Head contract to perform a context switch');

              case 6:
                _context2.next = 8;
                return this.blockchainStateWrapper.isAddressAContract(newContextAddress);

              case 8:
                if (_context2.sent) {
                  _context2.next = 10;
                  break;
                }

                throw new Error('Provided address is not a contract');

              case 10:
                _context2.next = 12;
                return this.headWrapper.setContext(newContextAddress);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function switchContext(_x2) {
        return _ref2.apply(this, arguments);
      }

      return switchContext;
    }()
  }, {
    key: 'showInfo',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
        var multiplexer, multisig, owners;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.t0 = console;
                _context3.next = 3;
                return this.feesWrapper.getOwner();

              case 3:
                _context3.t1 = _context3.sent;

                _context3.t0.log.call(_context3.t0, 'Multiplexer:', _context3.t1);

                _context3.t2 = _web3_tools.loadContract;
                _context3.t3 = this.headWrapper.web3;
                _context3.t4 = MultiplexerJson.abi;
                _context3.next = 10;
                return this.feesWrapper.getOwner();

              case 10:
                _context3.t5 = _context3.sent;
                _context3.next = 13;
                return (0, _context3.t2)(_context3.t3, _context3.t4, _context3.t5);

              case 13:
                multiplexer = _context3.sent;
                _context3.t6 = console;
                _context3.next = 17;
                return multiplexer.methods.owner().call();

              case 17:
                _context3.t7 = _context3.sent;

                _context3.t6.log.call(_context3.t6, 'Multisig:', _context3.t7);

                _context3.t8 = _web3_tools.loadContract;
                _context3.t9 = this.headWrapper.web3;
                _context3.t10 = MultisigWalletJson.abi;
                _context3.next = 24;
                return multiplexer.methods.owner().call();

              case 24:
                _context3.t11 = _context3.sent;
                _context3.next = 27;
                return (0, _context3.t8)(_context3.t9, _context3.t10, _context3.t11);

              case 27:
                multisig = _context3.sent;
                _context3.next = 30;
                return multisig.methods.getOwners().call();

              case 30:
                owners = _context3.sent;

                console.log('Multisig owners:', owners);

              case 32:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function showInfo() {
        return _ref3.apply(this, arguments);
      }

      return showInfo;
    }()
  }]);
  return AdministrativeActions;
}();

exports.default = AdministrativeActions;